import './abnLookup/.module';
import './ali/.module';
import './allianz/.module';
import './campaignMonitor/.module';
import './cashDeck/.module';
import './charting/.module';
import './compareClub/.module';
import './connect/.module';
import './coreLogic/.module';
import './creditFixSolution/.module';
import './drive/.module';
import stEditInvitationButton from './editInvitationButton.component';
import './email/.module';
import './equifax/.module';
import './eSign/.module';
import './flex/.module';
import './glasss/.module';
import './googleContacts/.module';
import './googleTasks/.module';
import './honey/.module';
import './idSmart/.module';
import './illion/.module';
import stIntegrationErrors from './integrationErrors.component';
import integrationsController from './integrations.controller';
import './jitsi/.module';
import './lid/.module';
import './loanq/.module';
import './mailChimp/.module';
import './mercury/.module';
import './mogo/.module';
import './movingHub/.module';
import './myConnect/.module';
import './nzbnLookup/.module';
import './openBanking/.module';
import './outlook/.module';
import './pepperAssetFinance/.module';
import './pepperResolve/.module';
import './ppsr/.module';
import './priceFinder/.module';
import './propertyData/.module';
import './settleEasy/.module';
import './slack/.module';
import stThirdPartyIntegrations from './thirdPartyIntegrations.component';
import './vero/.module';

export default angular
  .module('st.Integrations', [
    'st.Integrations.Ali',
    'st.Integrations.Allianz',
    'st.Integrations.ABNLookup',
    'st.Integrations.NZBNLookup',
    'st.Integrations.CampaignMonitor',
    'st.Integrations.CashDeck',
    'st.Integrations.Charting',
    'st.Integrations.CompareClub',
    'st.Integrations.Connect',
    'st.Integrations.CoreLogic',
    'st.Integrations.CreditFixSolution',
    'st.Integrations.Drive',
    'st.Integrations.Email',
    'st.Integrations.Equifax',
    'st.Integrations.ESign',
    'st.Integrations.Flex',
    'st.Integrations.Glass',
    'st.Integrations.GoogleContacts',
    'st.Integrations.GoogleTasks',
    'st.Integrations.Honey',
    'st.Integrations.IdSmart',
    'st.Integrations.Illion',
    'st.Integrations.Jitsi',
    'st.Integrations.LID',
    'st.Integrations.LoanQ',
    'st.Integrations.MailChimp',
    'st.Integrations.Mercury',
    'st.Integrations.Mogo',
    'st.Integrations.MovingHub',
    'st.Integrations.MyConnect',
    'st.Integrations.OpenBanking',
    'st.Integrations.Outlook',
    'st.Integrations.PepperAssetFinance',
    'st.Integrations.PepperResolve',
    'st.Integrations.Ppsr',
    'st.Integrations.PriceFinder',
    'st.Integrations.PropertyData',
    'st.Integrations.SettleEasy',
    'st.Integrations.Slack',
    'st.Integrations.Vero',
    'st.Integrations.PepperAssetFinance',
    'st.Core',
    'angular-cache'
  ])
  .controller('integrationsController', integrationsController)
  .component('stEditInvitationButton', stEditInvitationButton)
  .component('stIntegrationErrors', stIntegrationErrors)
  .component('stThirdPartyIntegrations', stThirdPartyIntegrations);
